<template>
    <div v-if="question.isShow" class="question-item">
        <div class="question-title">
            <i  v-if="question.tipColor == 1" >
                <img src="./image/red.png" alt="">
            </i>
            <i v-else-if="question.tipColor == 2" >
                <img src="./image/yellow.png" alt="">
            </i>
            <i  v-else-if="question.tipColor == 3" >
                <img src="./image/green.png" alt="">
            </i>
            <i v-if="question.isMust">*</i><span>第{{question.serialNumber}}题：</span>{{question.title}}</div>
        <div v-if="question.note" class="question-note">说明：{{question.note}}</div>
        <div class="qs-img-preview">
            <img :src="question.pictureUrl" alt="">
        </div>
        <div class="ql-editor" v-html="question.paragraphConfig.contentHtml"></div>
    </div>
</template>

<script>
  import './quill.core.css'

  export default {
    name: 'question-para',
    props: {
      question: { required: true },
    },
    data () {
      return {
        currentIndex: null,
        fileList: [],
        uploader: [],
        imageList: [],
        jumpPageNumber: null,
        show: false
      }
    },
    created (){
        this.getPicture()
    },
    watch: {
    },
    methods: {
        getPicture () {
            if (this.question.pictureUrl && this.question.pictureUrl.indexOf('http') == -1) {
                this.$store.dispatch('getPicture', { url: [this.question.pictureUrl] })
                    .then(res => {
                        this.question.pictureUrl = res[0]
                    })
            }
        },
        checkIsFill() {
            return true
        },
        saveAnswer() {

        }
    }
  }
</script>
<style lang="scss" scoped>
    @import "questionCommon";

    .question-option {
        .option-title {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            span {
                font-size: 16px;
                margin-left: 10px;
            }
        }

        .option-other {

        }
    }
</style>